import React, { Component } from "react";
import PropTypes from "prop-types";
import { translate as t } from "../../../../infrastructure/translate/localization";
import { cancelProcessEmployeesBulkSession } from "../../cancel-process-employees-bulk-session";
import { changeEditEmployeesBulkSession } from "../../change-edit-employees-bulk-session";

import ButtonLink from "../../../../app/components/commons/buttonLink/ButtonLink";
import ButtonAction from "../../../../app/components/commons/buttonAction/ButtonAction";
import SectionEmployeeSummary from "./SectionEmployeeSummary";

import "./employees-edit-summary-page.scss";
import { redirect } from "../../../../app/routes/Routes";

export default class EmployeesEditSummaryPage extends Component {
  constructor(props) {
    super(props);
    const { activeTable } = this.props;
    this.state = {
      isFetch: false,
      showTableContent: activeTable,
    };
  }

  setShowContent = (type) => {
    const { showTableContent } = this.state;
    if (showTableContent === type) {
      return this.setState({ showTableContent: "" });
    }
    return this.setState({ showTableContent: type });
  };

  handlerConfirm = () => {
    const { employeesForUpload } = this.props;
    this.setState({ isFetch: true });
    changeEditEmployeesBulkSession(employeesForUpload);
  };

  render() {
    const {
      employeesForUpload,
      employeesInFile,
      employeesErrors,
      employeesWarnings,
      employeesModified,
      employeesUnmodified,
    } = this.props;
    const { showTableContent, isFetch } = this.state;
    return (
      <main className="section">
        <div className="section-header with-link">
          <ButtonLink
            icon="arrow-left"
            textButton={t("employees-section.employees")}
            handlerClick={() => {
              redirect("/v2/employees");
            }}
          />
          <h1 className="section-title">
            {t("edit-employees.edit-employees-summary")}
          </h1>
        </div>

        <div className="section-container">
          <SectionEmployeeSummary
            employees={employeesErrors}
            showContent={showTableContent === "error"}
            sectionTitle={t("edit-employees.summary-error", {
              numEmployees: employeesErrors.length,
            })}
            sectionType="error"
            icon="exclamation-circle"
            messageDescription={t("edit-employees.msg-error")}
            handlerShowContent={() => this.setShowContent("error")}
          />

          <SectionEmployeeSummary
            employees={employeesWarnings}
            showContent={showTableContent === "warning"}
            sectionTitle={t("edit-employees.summary-warning", {
              numEmployees: employeesWarnings.length,
            })}
            sectionType="warning"
            icon="exclamation-circle"
            messageDescription={t("edit-employees.msg-warning")}
            handlerShowContent={() => this.setShowContent("warning")}
          />

          <SectionEmployeeSummary
            employees={employeesModified}
            showContent={showTableContent === "modified"}
            sectionTitle={t("edit-employees.summary-modified", {
              numEmployees: employeesModified.length,
            })}
            sectionType="modified"
            handlerShowContent={() => this.setShowContent("modified")}
          />

          <SectionEmployeeSummary
            employees={employeesUnmodified}
            showContent={showTableContent === "no-modified"}
            sectionTitle={t("edit-employees.summary-no-modified", {
              numEmployees: employeesUnmodified.length,
            })}
            sectionType="no-modified"
            handlerShowContent={() => this.setShowContent("no-modified")}
          />

          <div className="edit-employees-section-buttons">
            <p className="edit-employees-total">
              {t("edit-employees.edit-employees-upload-total", {
                numEmployees: employeesForUpload,
                totalEmployees: employeesInFile,
              })}
            </p>
            <div className="cob-btn-group right-group">
              <ButtonAction
                wrapperStyles="cancel-wrapper"
                textButton={t("actions.cancel")}
                typeButton="line"
                handlerClick={() => cancelProcessEmployeesBulkSession()}
              />
              <ButtonAction
                disabled={employeesForUpload === 0}
                wrapperStyles="confirm-wrapper"
                textButton={t("actions.confirm-edit")}
                textLoadingButton={t("common-messages.loading-data")}
                loading={isFetch}
                handlerClick={this.handlerConfirm}
              />
            </div>
          </div>
        </div>
      </main>
    );
  }
}

EmployeesEditSummaryPage.defaultProps = {};
EmployeesEditSummaryPage.propTypes = {
  activeTable: PropTypes.string.isRequired,
  employeesForUpload: PropTypes.number.isRequired,
  employeesInFile: PropTypes.number.isRequired,
  employeesErrors: PropTypes.array.isRequired,
  employeesWarnings: PropTypes.array.isRequired,
  employeesModified: PropTypes.array.isRequired,
  employeesUnmodified: PropTypes.array.isRequired,
};
